import { Typography } from "@material-ui/core";
import React from "react";
import JSONEditor from "../../../components/JSONEditor/JSONEditor";
import { useStyles } from "./styles";
import { IoTKeyCommandType } from "../iotKeyTypes";


type IoTKeyCommandEditorProps = {
  IoTKeyCommand: IoTKeyCommandType;
  onIoTKeyCommandChanged: (json: any) => void;
};

const IoTKeyCommandEditor: React.FC<IoTKeyCommandEditorProps> = ({
  IoTKeyCommand,
  onIoTKeyCommandChanged = () => {},
}) => {
  const classes = useStyles();

  const jsonChanged = (json: string) => {
    try {
      JSON.parse(json);
    } catch (e) {
      return;
    }
    const { name, command, companies, parameters } =
      JSON.parse(json);
    onIoTKeyCommandChanged({
      name,
      command,
      companies,
      parameters,
    });
  };

  return (
    <JSONEditor
      value={IoTKeyCommand}
      width="100%"
      jsonChanged={jsonChanged}
      className={classes.editor}
      customTitle={
        <Typography variant="subtitle1" className={classes.title}>
          IoT Key Command JSON
        </Typography>
      }
    />
  );
};

export default IoTKeyCommandEditor;
